module.exports = __webpack_public_path__ + "img/yj_virtual_coin_to_see.0eadafae.png";